import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const archiveEmployeeTemplate = async (uuid: string) => {
  const response = await CustomAxios.post(`employee_templates/${uuid}/archive`);
  return response.data;
};

interface UseArchiveEmployeeTemplateProps {
  uuid: string;
  onSuccessCallback: () => void;
}

export function useArchiveEmployeeTemplate({ uuid, onSuccessCallback }: UseArchiveEmployeeTemplateProps) {
  return useMutation({
    mutationFn: () => archiveEmployeeTemplate(uuid),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [queryKeys.allEmployeeTemplates, uuid],
      });
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        alert('Failed to archive the employee template. Please try again and contact support if the problem persists.');
      } else {
        console.error('Unexpected error archiving employee template:', err);
      }
    },
  });
}
